import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@fullyops/shared/material.module';
import { I18NextModule } from 'angular-i18next';

export type RequestPartConfirmationDialogResult = 'saveAndContinue' | 'cancel';

@Component({
  selector: 'fo-request-part-confirmation-dialog',
  templateUrl: './request-part-confirmation-dialog.component.html',
  styleUrls: ['./request-part-confirmation-dialog.component.scss'],
  imports: [MaterialModule, I18NextModule],
})
export class RequestPartConfirmationDialogComponent {
  constructor(
    protected dialogRef: MatDialogRef<RequestPartConfirmationDialogComponent>,
  ) {}

  onSaveAndContinue(): void {
    this.dialogRef.close('saveAndContinue');
  }
}
